export { AdultosLanding } from "./AdultosLanding";
